import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OperatorFunction, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { catchErrorLogRet, mapRetrieve } from '../common/rest.operators';

import { LookupBox } from './general';

@Injectable()
export class NextCoachingService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    retrieveLookupBox<T>(): OperatorFunction<T, LookupBox> {
        return pipe(
            switchMap(() =>
                this._http.get(
                    `${this._appConfig.API_ENDPOINTS.COACHING}/coaching/lookupbox`,
                ),
            ),
            mapRetrieve(),
            map<any, LookupBox>((e) => {
                return {
                    behaviours: (e.behaviours as any[])?.map((item) => {
                        return {
                            id: item.id,
                            initials: item.text,
                            shortName: item.text,
                            name: item.text,
                        };
                    }),
                    subBehaviours: (e.subBehaviours as any[])?.map((item) => {
                        return {
                            id: item.id,
                            initials: item.text,
                            shortName: item.text,
                            name: item.text,
                            behaviourId: item.relatedId,
                        };
                    }),
                    metrics: (e.metrics as any[])?.map((item) => {
                        return {
                            id: item.id,
                            initials: item.initials,
                            shortName: item.shortName,
                            name: item.fullName,
                            rankOrder: null,
                        };
                    }),
                };
            }),
            catchErrorLogRet({}),
        );
    }
}
